var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a1 1 0 0 0 1 1h14a1 1 0 0 0 0-2H1a1 1 0 0 0-1 1Zm1 6a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H1Zm0 5a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H1Z",
    fill: "inherit"
  })));
};
export default SvgBurger;